import Grid from '@mui/material/Grid';
import Drawer from 'components/Drawer';
import BaseTable from 'components/Tables/BaseTable';
import { actions as rawMaterialsActions } from 'ducks/rawMaterials';
import { setContextSearchRM } from 'ducks/ui';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import docDefinition from 'reports/inventory/consumptions';
import { filterByFunctionSelector, groupBy } from 'selectors/generic';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/inventory/consumptions';
import ConsumptionsDetailPanel from './ConsumptionsDetailPanel';
import ConsumptionsTable from './ConsumptionsTable';

pdfMake.addVirtualFileSystem(pdfFonts);

const Component = props => {
  const {
    consumptionsByRawMaterial, consumptionsById, loading, contextSearch,
    rawMaterialsById, rawMaterialsData
  } = props;
  const { create, remove, setSearch, update } = props;
  const tableRef = useRef();

  const [mpId, setMpId] = useState(undefined);
  const onCloseDrawer = () => setMpId(undefined);

  // useEffect(() => {
  //   toggleState.forEach(row =>
  //     tableRef.current.onToggleDetailPanel([row], tableRef.current.props.detailPanel)
  //   )
  // }, []);

  // const addToDetailPanel = (row) => {
  //   console.log('RUNS!!!!!', row, !panelDetailState.includes(row));
  //   if(panelDetailState.includes(row)) {
  //     console.log('RUNS!!!!! INSIDE');
  //     const tempState = [...panelDetailState];
  //     tempState.push(row);
  //     setPanelDetailState(tempState);
  //   }
  // };

  const onUpdate = (newData) => {
    update(newData.id, { observations: newData.observations });
    return Promise.resolve();
  };

  return (
    <Grid size={12}>
      <BaseTable
        ref={tableRef}
        columns={columns(consumptionsByRawMaterial)}
        data={rawMaterialsData}
        onRowClick={() => null}
        onRowDoubleClick={rowData => setMpId(rowData.id)}
        isLoading={loading}
        onSearchChange={ text => setSearch(text)}
        options={{
          searchText: contextSearch,
        }}
        detailPanel={[
          rowData => ({
            disabled: (consumptionsByRawMaterial[rowData.id] || []).length === 0,
            icon: tableIcons.Consumptions,
            render: () => <ConsumptionsDetailPanel rowData={consumptionsByRawMaterial[rowData.id] || []} data={consumptionsById} title={'Consumos'}/>
          })
        ]}
        actions={[
          {
            isFreeAction: true,
            icon: tableIcons.Pdf,
            tooltip: 'Generate Report',
            // onClick: (event, rowData) => null,
            onClick: (event, rowData) => {
              pdfMake.createPdf(docDefinition(rawMaterialsData, rawMaterialsById, consumptionsById)).open();
            }
          },
          {
            icon: tableIcons.Add,
            tooltip: 'Add Consumption',
            onClick: (event, rowData) => {
              setMpId(rowData.id);
            }
          }
        ]}
        editable={{
          onRowUpdate: onUpdate
        }}
      />
      {mpId &&
      <Drawer open={true} onClose={onCloseDrawer}>
        {mpId &&
        <ConsumptionsTable
          mpId={mpId}
          mpConsumptions={consumptionsByRawMaterial[mpId] || []} create={create} remove={remove} update={update}
          onCloseDrawer={onCloseDrawer}
        />
        }
      </Drawer>
      }
    </Grid>
  );
};

const makeMapStateToProps = () => {
  const filteredRawMaterials = filterByFunctionSelector('rawMaterials', rm => rm.code !== null && rm.code !== '');
  // `rm.consumptions` was a list of ids on the row; the consumption rows name
  // their raw material, so one index answers it for every row on screen.
  const consumptionsByRawMaterial = groupBy('rawMaterialConsumptions', 'raw_material_id');
  const mapStateToProps = (state, props) => ({
    consumptionsByRawMaterial: consumptionsByRawMaterial(state),
    contextSearch: state.ui.context.searchRM,
    loading: state.rawMaterials.loading,
    rawMaterialsData: filteredRawMaterials(state),
    rawMaterialsById: state.rawMaterials.models,
    consumptionsById: state.rawMaterialConsumptions.models
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  setSearch: search => dispatch(setContextSearchRM(search)),
  update: (id, data) => dispatch(rawMaterialsActions.update(id, data)),
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
